import { render } from "./index.vue?vue&type=template&id=22a31c14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=22a31c14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a31c14"],['__file',"src/components/BaseUi/FormNameSignUp2/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22a31c14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22a31c14', __exports__)) {
    api.reload('22a31c14', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=22a31c14&scoped=true", () => {
    api.rerender('22a31c14', render)
  })

}


export default __exports__